import { httpService } from "../../HttpService";
import { FeatureFlagResponse } from "../../../models/FeatureFlag";

const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

interface CacheEntry {
    enabled: boolean;
    fetchedAt: number;
}

const flagCache = new Map<string, CacheEntry>();

// Generic Flagsmith flag lookup via CRM's GET /FeatureFlag (the list): CRM has no GET by name, and its
// POST /FeatureFlag/by-name is not published through the gateway. Unlike
// FastPayFeatureFlagService (a bundle endpoint scoped to MerchantVendor), this checks any
// individual flag by name, e.g. "merchantportal.additional_documents".
class FeatureFlagApiService {
    private readonly path: string = "FeatureFlag";

    isEnabled = async (flagName: string): Promise<boolean> => {
        const cached = flagCache.get(flagName);
        if (cached && Date.now() - cached.fetchedAt < CACHE_TTL_MS) {
            return cached.enabled;
        }

        try {
            const result = await httpService.get<FeatureFlagResponse[]>(this.path);
            const enabled = result.success && result.data?.some((flag) => flag.name === flagName && flag.enabled) === true;
            flagCache.set(flagName, { enabled, fetchedAt: Date.now() });
            return enabled;
        } catch {
            return false;
        }
    };
}

const featureFlagApiService = new FeatureFlagApiService();
export { featureFlagApiService };
